module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-titlepage title-page",
    attrs: {
      "epub:type": "titlepage",
      "id": "title-page"
    }
  }, [_c('div', {
    staticClass: "title-page-title-subtitle-block"
  }, [_c('h1', {
    staticClass: "title-page-title case-upper"
  }, [_vm._v("WHAT LIES IN THE DARK")])]), _vm._v(" "), _c('div', {
    staticClass: "title-page-contributor-block"
  }, [_c('div', {
    staticClass: "title-page-contributor-primary-block"
  }, [_c('h2', {
    staticClass: "title-page-contributor title-page-contributor-primary title-page-contributor-without-introduction"
  }, [_c('span', {
    staticClass: "title-page-contributor-name case-upper"
  }, [_vm._v("CM THOMPSON")])])])]), _vm._v(" "), _c('div', {
    staticClass: "publisher-block"
  }, [_c('div', {
    staticClass: "title-page-publisher-logo-block title-page-publisher-logo-aspect-wide"
  }, [_c('div', {
    staticClass: "title-page-publisher-logo-size-container publisher-logo-width-600"
  }, [_c('a', {
    staticClass: "link-contains-image",
    attrs: {
      "href": "http://www.bloodhoundbooks.com",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "title-page-publisher-logo-image",
    attrs: {
      "alt": "Bloodhound Books",
      "src": "images/bloodhoundbooks-logo-2-copy.jpg"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b65658c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/title-page.vue
// module id = 60
// module chunks = 0